export default __webpack_public_path__ + "static/media/Chelsea2.eb3b1cc1.jpg";